import { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { CATEGORY_ORDER, groupBy } from "@/lib/format";
import { cn } from "@/lib/utils";

export default function ProductMultiSelect({ products, value, onChange }) {
  const [open, setOpen] = useState(false);
  const list = (products || []).filter((p) => !p.is_bundle);
  const groups = groupBy(list, (p) => p.category);
  const toggle = (id) => onChange(value.includes(id) ? value.filter((x) => x !== id) : [...value, id]);
  const label = !value.length ? "Semua produk aktif" : value.length === 1 ? list.find((p) => p.id === value[0])?.name : `${value.length} items selected`;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid="kartu-product-multiselect" className="press flex h-12 w-full items-center gap-2 rounded-md border border-zinc-300 bg-white px-3 text-left text-sm hover:border-ink">
          <span className="flex-1 truncate">{label}</span><ChevronsUpDown className="h-4 w-4 text-zinc-400" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[320px] p-0" align="start">
        <div className="flex gap-2 border-b p-2">
          <button className="flex-1 rounded border px-2 py-1.5 text-xs font-semibold hover:bg-zinc-50" onClick={() => onChange(list.filter((p) => p.active).map((p) => p.id))} data-testid="kartu-select-all">Pilih semua</button>
          <button className="flex-1 rounded border px-2 py-1.5 text-xs font-semibold hover:bg-zinc-50" onClick={() => onChange([])} data-testid="kartu-select-clear">Kosongkan</button>
        </div>
        <Command>
          <CommandInput placeholder="Cari produk..." />
          <CommandList className="max-h-72">
            <CommandEmpty>Tidak ditemukan.</CommandEmpty>
            {CATEGORY_ORDER.filter((c) => groups[c]).map((c) => (
              <CommandGroup key={c} heading={c}>
                {groups[c].map((p) => (
                  <CommandItem key={p.id} value={`${p.code} ${p.name}`} onSelect={() => toggle(p.id)} data-testid={`kartu-option-${p.code}`}>
                    <span className={cn("grid h-4 w-4 place-items-center rounded-sm border border-ink", value.includes(p.id) && "bg-ink text-white")}>{value.includes(p.id) && <Check className="h-3 w-3" />}</span>
                    <span className="flex-1 truncate">{p.name}</span>
                  </CommandItem>
                ))}
              </CommandGroup>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
